
<!--mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar-->
<ngx-spinner bdColor = "rgba(255, 255, 255, 0.8)" [template]="ThemeService.getSpinnerTemplate()"  size = "medium" color = "#fff" type = "ball-clip-rotate-multiple" [fullScreen] = "false" [name]="'infoLoading'">
    <p style="font-size: 20px; color: white">Carregando Informações...</p>
</ngx-spinner>           
<div class="main-content-edit" *ngIf="!loading">
    <editform 
        [removeReference]="removeReference"
        [parentRow]="parentRow"
        [entityName]="entityName"
        [row]="row"
        [filter]="filter"
        [userConfig]="userConfig"
        [tableInformation]="tableInformation"
        [formViewColumns]="formViewColumns"
        [formGroup]="formGroup"
        [evento]="evento"
        [$$REFERENCES]="$$REFERENCES"
        [actionList]="actionList"          
        (saving)="savingForm($event)"
        >
    </editform>
          
</div>